import { render, staticRenderFns } from "./list.vue?vue&type=template&id=622b2a83&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=622b2a83&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b2a83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('622b2a83')) {
      api.createRecord('622b2a83', component.options)
    } else {
      api.reload('622b2a83', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=622b2a83&scoped=true", function () {
      api.rerender('622b2a83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/statisticsManagement/statisticsSurvey/list.vue"
export default component.exports